export default __webpack_public_path__ + "static/media/lima-costa_verde_sunset.12c0d29b.jpg";